import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'layout-navbar-inactive',
  'IconLayoutNavbarInactive',
  [
    [
      'path',
      {
        d: 'M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z',
        key: 'svg-0',
      },
    ],
    ['path', { d: 'M4 9h1', key: 'svg-1' }],
    ['path', { d: 'M19 9h1', key: 'svg-2' }],
    ['path', { d: 'M9 9h1', key: 'svg-3' }],
    ['path', { d: 'M14 9h1', key: 'svg-4' }],
  ],
);
